export function iriFromId(resource, id) {
    if (id === null) {
        return null;
    }
    return `/${resource}/${id}`;
}
